(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('ProductFormController', ProductFormController);

  /* ngInject */
  function ProductFormController($state, $stateParams, Flash, vmsProductService, productCategoryService, sessionService, vendorService) {
    const vm = this;

    vm.id = $stateParams.id;
    vm.product = {};
    vm.productCategories = [];
    vm.saveProduct = saveProduct;
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      if (vm.id) {
        getProduct();
      }

      getProductCategories();
      getVendor();
    }

    function getProduct() {
      vmsProductService(sessionService.getAuthToken()).get({ vendorId: vm.vendorId, id: vm.id }, response => vm.product = response);
    }

    function getProductCategories() {
      productCategoryService(sessionService.getAuthToken()).query({}, response => vm.productCategories = response);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }

    function saveProduct() {
      if (vm.id) {
        vmsProductService(sessionService.getAuthToken()).update({ vendorId: vm.vendorId, id: vm.id }, vm.product,
          response => {
            $state.go('application.vms.product-detail', { vendorId: vm.vendorId, id: response.product.id });
            Flash.create('success', 'Product successfully created.');
          },
          _ => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
          }
        );
      } else {
        vmsProductService(sessionService.getAuthToken()).save({ vendorId: vm.vendorId }, vm.product,
        response => {
          $state.go('application.vms.product-detail', { vendorId: vm.vendorId, id: response.product.id });
          Flash.create('success', 'Product successfully created.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
        });
      }
    }
  }
})();
